/**
 * Базовый URL
 * @returns {string} URL
 */
export const entryScriptName = (() => {
  if (process.env.NODE_ENV === 'test') {
    return 'test-entry'
  }
  return window.app && window.app.entryScriptName
})()
